import { ReactNode } from 'react';

import { Styles, css } from '@flipster/styled-system/css';
import { center, hstack } from '@flipster/styled-system/patterns';

export const SparkRewardShare = ({
  css: cssProp,
  ShareCta = 'button',
}: {
  css?: Styles;
  ShareCta?: string | ((props: { className?: string; children?: ReactNode }) => ReactNode);
}) => {
  return (
    <div className={css(center.raw(), cssProp)}>
      <ShareCta
        className={hstack({
          gap: 4,
          height: 50,
          px: 24,
          borderColor: 'border.default.level-2',
          borderStyle: 'solid',
          borderWidth: 1,
          textStyle: 'Text/L/Strong',
          color: 'content.default.level-5',
          rounded: 4,
          userSelect: 'none',
          textDecoration: 'none',
          outline: 'none',
        })}
      >
        {/* TODO: 디자인시스템에 이 아이콘 추가되면 import 해서 사용하기 */}
        <svg width='24' height='24' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M14.375 8.25C15.8247 8.25 17 7.07475 17 5.625C17 4.17525 15.8247 3 14.375 3C12.9253 3 11.75 4.17525 11.75 5.625C11.75 5.7348 11.7567 5.84302 11.7698 5.94928L7.44727 8.11056C6.97515 7.65513 6.33279 7.375 5.625 7.375C4.17525 7.375 3 8.55025 3 10C3 11.4497 4.17525 12.625 5.625 12.625C6.33281 12.625 6.97518 12.3449 7.4473 11.8894L11.7698 14.0507C11.7567 14.1569 11.75 14.2652 11.75 14.375C11.75 15.8247 12.9253 17 14.375 17C15.8247 17 17 15.8247 17 14.375C17 12.9253 15.8247 11.75 14.375 11.75C13.6672 11.75 13.0248 12.0301 12.5527 12.4856L8.23017 10.3243C8.24326 10.218 8.25 10.1098 8.25 10C8.25 9.89019 8.24326 9.78195 8.23016 9.67568L12.5527 7.51441C13.0248 7.96986 13.6672 8.25 14.375 8.25Z'
            fill='currentColor'
          />
        </svg>
        Share Spark Rewards Season 1
      </ShareCta>
    </div>
  );
};
